import exp from "constants";
import { IXetTotNghiepLanXetUpdateLockStatusRequest } from "../../../model/request/xet-tot-nghiep/IXetTotNghiepLanXetUpdateLockStatusRequest";
import { IXetTotNghiepLanXet } from "../../../model/response/xet-tot-nghiep/IXetTotNghiepLanXet";
import { IXetTotNghiepLanXetViewModel } from "../../../model/response/xet-tot-nghiep/IXetTotNghiepLanXetViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eXetTotNghiepLanXetActionsObj = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as IXetTotNghiepLanXetViewModel[],
    LOAD_ERROR: "",

    SAVE_START: {} as IXetTotNghiepLanXet,
    SAVE_SUCCESS: undefined,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",

    SHOW_EDIT_MODAL: {} as IXetTotNghiepLanXet | undefined,
    CLOSE_EDIT_MODAL: undefined,

    UPDATE_LOCK_STATUS_START: {} as IXetTotNghiepLanXetUpdateLockStatusRequest,
    UPDATE_LOCK_STATUS_SUCCESS: undefined,
    UPDATE_LOCK_STATUS_ERROR: "",
}

export const eXetTotNghiepLanXetActionIds = generateActionTypeIds(eXetTotNghiepLanXetActionsObj, "XET_TOT_NGHIEP_LAN_XET");
export type IXetTotNghiepLanXetActionTypes = IGenericActionType<typeof eXetTotNghiepLanXetActionsObj, "XET_TOT_NGHIEP_LAN_XET">;